export default "__VITE_ASSET__DVBKuZmw__"